import { render } from "./BlogPost.vue?vue&type=template&id=1f152cb0&ts=true"
import script from "./BlogPost.vue?vue&type=script&lang=ts"
export * from "./BlogPost.vue?vue&type=script&lang=ts"

import "./BlogPost.vue?vue&type=style&index=0&id=1f152cb0&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__